// removed by extract-text-webpack-plugin
module.exports = {"pagination":"_1L5ay5rTWdmO0Ypa646hdQ","text-center":"_3d0JzyyGmppbV8LmdzEeQb"};


//////////////////
// WEBPACK FOOTER
// ./components/NotificationHistory/style.less
// module id = 1229
// module chunks = 0